/**
 * Illustrative social-proof pings for the landing page ticker.
 *
 * IMPORTANT: This is a marketing-grade widget — the data below is illustrative,
 * not real user activity. Every ping uses generic company archetypes; no real
 * customer names appear here. The landing renders a disclosure line under the
 * ticker: "Illustrative activity — actual customer names withheld for privacy."
 *
 * The frontend cycles this array through a marquee-style scroll. Portraits
 * reference the 6 functional worker slugs — the SocialProofBand component
 * pairs each ping with the live avatar URL from GET /api/workers/catalog.
 */

const SOCIAL_PROOF_PINGS = [
    { slug: "ivan-legal",       body: "A mid-market SaaS just activated **Ivan**",                                 ts: "3 min ago" },
    { slug: "sofia-data",       body: "A public-sector team just activated **Sofia**",                             ts: "12 min ago" },
    { slug: "aria-content",     body: "A consultancy installed **Content Amplifier Skill Pack** on Aria",      ts: "18 min ago" },
    { slug: "kenji-support",    body: "A healthcare admin group connected **Zendesk** to Kenji",               ts: "22 min ago" },
    { slug: "marcus-recruiter", body: "A growth-stage startup completed 12 candidate screens with Marcus",     ts: "34 min ago" },
    { slug: "elena-exec",       body: "An executive team hired **Elena** as their AI Chief of Staff",          ts: "41 min ago" },
    { slug: "ivan-legal",       body: "A legal ops team cleared 47 contract reviews with Ivan",                ts: "1 hr ago" },
    { slug: "sofia-data",       body: "A finance team built 3 revenue dashboards with Sofia",                  ts: "1 hr ago" },
    { slug: "aria-content",     body: "A brand team shipped 22 blog posts through Aria this week",             ts: "2 hr ago" },
    { slug: "kenji-support",    body: "A support desk resolved 340 tickets with Kenji today",                  ts: "3 hr ago" },
    { slug: "marcus-recruiter", body: "A recruiting team cut time-to-hire by 41% with Marcus",                 ts: "yesterday" },
    { slug: "elena-exec",       body: "An executive reclaimed 12 hours this week with Elena",                  ts: "yesterday" },
    { slug: "ivan-legal",       body: "A GC flagged $2M in contract risk using Ivan",                          ts: "2 days ago" },
    { slug: "sofia-data",       body: "A CFO detected $1.4M in revenue leakage with Sofia",                    ts: "3 days ago" },
    { slug: "aria-content",     body: "A CMO grew organic traffic 3× with Aria",                               ts: "this month" },
];

export default SOCIAL_PROOF_PINGS;
